import {Alert} from "@mui/material";
import {api} from "../../../../api/API";
import {CentsCol, NumberCol, RenderStringCol, Table} from "../../../../misc/scroller/Table";
import {ProductUsage} from "../../../../api/Products";
import {projectLabel} from "../../../../api/Projects";

export function ProductProjectUsage(props: {
    product?: number;
}) {
    if(!props.product) {
        return (
            <Alert severity="info">
                Please finish creating the product first
            </Alert>
        )
    }

    return <UsageInner product={props.product} />
}

function UsageInner(props: {
    product: number;
}) {

    return (
        <div style={{minHeight: 400, display: "flex", flexDirection: "column", marginLeft: -24, marginRight: -24}}>
            <Table<ProductUsage>
                name="product-project-usage"
                columns={[
                    RenderStringCol<ProductUsage>("Project", v => {
                        const label = projectLabel({projectNumber: v.projectNumber, name: v.projectName});
                        return v.projectStage === "quote" ? label + " (Quote Mode)" : label;
                    }, 300),
                    NumberCol("Qty", "qty"),
                    CentsCol("Avg Cost", "avgUnitCostCents"),
                    NumberCol("Avg Markup %", "avgMarkupPercent"),
                ]}
                fetch={ctx => api.products.listProjectUsage({
                    product: props.product,
                })}
                fetchDeps={[props.product]}
            />
        </div>
    )
}